webpackJsonp([15867762484163],{

/***/ "./src/components/GuideArticle.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Article = undefined;
	
	var _sideBar, _callToActionText, _callToActionIcon;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _breakpoints = __webpack_require__("./src/utils/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _radium = __webpack_require__("./node_modules/radium/lib/index.js");
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _marked = __webpack_require__("./node_modules/marked/lib/marked.js");
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _utilFunctions = __webpack_require__("./src/utils/util-functions.js");
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Article = exports.Article = function (_Component) {
	  _inherits(Article, _Component);
	
	  function Article(props, context) {
	    _classCallCheck(this, Article);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.state = {
	      linkString: props.path,
	      activeLink: props.activeLink
	    };
	    _this.refreshPage = _this.refreshPage.bind(_this);
	    _this.goToBooking = _this.goToBooking.bind(_this);
	    return _this;
	  }
	
	  Article.prototype.refreshPage = function refreshPage() {
	    window.location.reload();
	  };
	
	  Article.prototype.goToBooking = function goToBooking(name) {
	    this.props.history.push('/bookingform/#service=' + name);
	    (0, _utilFunctions.eventDispatch)('hashchange');
	  };
	
	  Article.prototype.render = function render() {
	    var _this2 = this;
	
	    var article = _lodash2.default.find(this.props.articles, function (item) {
	      return item.url === _this2.state.activeLink;
	    });
	    var image = article.item.articleImage ? article.item.articleImage.fields.file.url : null;
	    var headline = article.item.articleHeadline;
	    var callToAction = article.item.callToAction;
	    var introduction = article.item.articleIntroduction;
	    var text = article.item.articleText;
	    var articles = this.props.articles;
	    var articleTypeTitles = articles.map(function (item) {
	      return item.item.articleType.fields.title;
	    }).filter(function (elem, pos, arr) {
	      return arr.indexOf(elem) === pos;
	    });
	    var path = this.props.path;
	    return _react2.default.createElement(
	      'div',
	      { style: styles.main, className: 'guideArticle' },
	      _react2.default.createElement(
	        _radium.StyleRoot,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-7 col-xs-12' },
	          image && _react2.default.createElement('img', { style: styles.img, src: image }),
	          _react2.default.createElement(
	            'h1',
	            { style: styles.headline },
	            headline
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            introduction
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            callToAction && _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-sm-10', style: styles.callToAction, onClick: function onClick() {
	                  return _this2.goToBooking(callToAction);
	                } },
	              _react2.default.createElement(
	                'div',
	                { style: styles.callToActionText, className: 'col-sm-10 col-xs-12' },
	                callToAction
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-2' },
	                _react2.default.createElement('i', { className: 'glyphicon glyphicon-chevron-right', style: styles.callToActionIcon })
	              )
	            ),
	            _react2.default.createElement('div', { className: 'clearfix' })
	          ),
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(text) } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-xs-12 col-sm-4 col-sm-offset-1', style: styles.sideBar },
	          articleTypeTitles.map(function (title) {
	            return _react2.default.createElement(
	              'div',
	              { key: title },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                ' ',
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  title
	                )
	              ),
	              _react2.default.createElement('div', { style: styles.responsiveDivider }),
	              _react2.default.createElement('div', { className: 'clearfix' }),
	              articles.map(function (item, i) {
	                if (title === item.item.articleType.fields.title) {
	                  var linkString = "/" + path + "/#article=" + item.url;
	                  if (_this2.state.activeLink === item.url) {
	                    return _react2.default.createElement(
	                      'div',
	                      { key: i },
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { className: 'articleItemActive', to: linkString, onClick: _this2.refreshPage, style: styles.articleListItemActive },
	                        item.item.articleHeadline
	                      )
	                    );
	                  } else {
	                    return _react2.default.createElement(
	                      'div',
	                      { key: i },
	                      _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: linkString, onClick: _this2.refreshPage, style: styles.articleListItem },
	                        item.item.articleHeadline
	                      )
	                    );
	                  }
	                }
	              })
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return Article;
	}(_react.Component);
	
	exports.default = (0, _radium2.default)(Article);
	
	
	var styles = {
	  main: {},
	  headline: {
	    marginBottom: 40,
	    fontFamily: 'Merriweather',
	    fontWeight: 'bold',
	    lineHeight: 1.4
	  },
	  img: {
	    width: '100%'
	  },
	  articleListItem: {
	    display: 'block',
	    padding: 20,
	    textDecoration: 'none',
	    color: _colors2.default.black,
	    paddingTop: 30,
	    paddingBottom: 30,
	    paddingLeft: 10,
	    fontSize: 16,
	    paddingRight: 10,
	    borderBottom: 'solid' + _colors2.default.lightBrown + ' 2px'
	  },
	  articleListItemActive: {
	    display: 'block',
	    paddingTop: 34,
	    paddingBottom: 26,
	    paddingLeft: 25,
	    paddingRight: 10,
	    marginLeft: -15,
	    marginTop: -4,
	    fontSize: 16,
	    marginBottom: 6,
	    textDecoration: 'none',
	    color: _colors2.default.black,
	    backgroundColor: _colors2.default.lightBrown,
	    borderRadius: _breakpoints2.default.borderRadius
	  },
	  sideBar: (_sideBar = {
	    borderLeft: 'solid black 1px'
	  }, _sideBar[_breakpoints2.default.media.siteUnderPadWidth] = {
	    borderLeft: 'none',
	    paddingLeft: 0,
	    paddingRight: 0
	  }, _sideBar),
	  callToAction: {
	    backgroundColor: _colors2.default.darkBlue,
	    borderRadius: _breakpoints2.default.borderRadius,
	    marginTop: _breakpoints2.default.componentDivider,
	    marginBottom: _breakpoints2.default.componentDivider,
	    ':hover': {}
	  },
	  callToActionText: (_callToActionText = {
	    padding: 35,
	    color: '#ffffff'
	  }, _callToActionText[_breakpoints2.default.media.siteUnderPadWidth] = {
	    padding: 20
	  }, _callToActionText),
	  callToActionIcon: (_callToActionIcon = {
	    fontSize: 30,
	    padding: 20,
	    top: 10,
	    color: _colors2.default.mainBlue,
	    float: 'right',
	    borderBottomRightRadius: _breakpoints2.default.borderRadius,
	    borderTopRightRadius: _breakpoints2.default.borderRadius,
	    backgroundColor: '#ffffff'
	  }, _callToActionIcon[_breakpoints2.default.media.siteUnderPadWidth] = {
	    display: 'none'
	  }, _callToActionIcon)
	};

/***/ }),

/***/ "./src/components/NewsLetter.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _main, _input, _icon;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__("./node_modules/radium/lib/index.js");
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _breakpoints = __webpack_require__("./src/utils/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _data = __webpack_require__("./contentfuldata/data.json");
	
	var _data2 = _interopRequireDefault(_data);
	
	__webpack_require__("./node_modules/whatwg-fetch/fetch.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsLetter = function (_Component) {
	  _inherits(NewsLetter, _Component);
	
	  function NewsLetter(props, context) {
	    _classCallCheck(this, NewsLetter);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.state = {
	      email: "",
	      formSent: { error: "", success: "" },
	      newsletterSent: false
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.orderNewsletter = _this.orderNewsletter.bind(_this);
	    return _this;
	  }
	
	  NewsLetter.prototype.orderNewsletter = function orderNewsletter(e) {
	    var _this2 = this;
	
	    var formUrl = "https://cx5j4s9rc2.execute-api.eu-west-1.amazonaws.com/prod/SaveEmailToS3";
	    var brand = getLang();
	    var successText = _data2.default.singleData[brand].singleData.formSentText;
	    this.setState({
	      newsletterSent: true
	    });
	    if (this.state.email.length > 3) {
	      fetch(formUrl, {
	        method: 'POST',
	        mode: 'no-cors',
	        headers: { 'Access-Control-Allow-Origin': '*' },
	        body: JSON.stringify({ email: this.state.email })
	      }).then(function (response) {
	        return response;
	      }).then(function (json) {
	        _this2.setState({
	          formSent: { success: successText },
	          email: ""
	        });
	      }).catch(function (ex) {
	        _this2.setState({
	          email: ""
	        });
	      });
	    }
	  };
	
	  NewsLetter.prototype.handleChange = function handleChange(event) {
	    var target = event.target;
	    this.setState({
	      email: target.value
	    });
	  };
	
	  NewsLetter.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: styles.main },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6', style: styles.text },
	        _react2.default.createElement(
	          'p',
	          null,
	          this.props.text
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-sm-6' },
	        !this.state.newsletterSent && _react2.default.createElement(
	          'div',
	          { className: 'input-group' },
	          _react2.default.createElement('input', { style: styles.input, className: 'form-control', placeholder: 'E-mail', value: this.state.email, onChange: this.handleChange }),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'input-group-addon', onClick: this.orderNewsletter },
	            _react2.default.createElement('i', { className: 'glyphicon glyphicon-chevron-right', style: styles.icon })
	          )
	        ),
	        this.state.formSent.success !== "" && _react2.default.createElement(
	          'div',
	          { style: styles.formsent, className: 'col-xs-12' },
	          this.state.formSent.success
	        )
	      ),
	      _react2.default.createElement('div', { className: 'clearfix' })
	    );
	  };
	
	  return NewsLetter;
	}(_react.Component);
	
	var styles = {
	  main: (_main = {
	    backgroundColor: _colors2.default.darkBlue,
	    padding: 30,
	    borderRadius: _breakpoints2.default.borderRadius
	  }, _main[_breakpoints2.default.media.siteUnderMaxWidth] = {
	    paddingTop: 15,
	    paddingLeft: 15,
	    paddingRight: 15,
	    paddingBottom: 30
	  }, _main),
	  input: (_input = {
	    padding: 30
	  }, _input[_breakpoints2.default.media.siteUnderMaxWidth] = {
	    padding: 10
	  }, _input),
	  icon: (_icon = {
	    padding: 17
	  }, _icon[_breakpoints2.default.media.siteUnderMaxWidth] = {
	    padding: 0,
	    fontSize: 12
	  }, _icon),
	  text: {
	    color: '#ffffff'
	  },
	  formsent: {
	    marginTop: 10,
	    padding: 18,
	    backgroundColor: "#218838",
	    color: "#ffffff",
	    textAlign: 'center',
	    textTransform: 'uppercase',
	    borderRadius: _breakpoints2.default.borderRadius
	  }
	};
	
	exports.default = (0, _radium2.default)(NewsLetter);
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/ParentGuide.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ParentGuide = undefined;
	
	var _styles;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _data = __webpack_require__("./contentfuldata/data.json");
	
	var _data2 = _interopRequireDefault(_data);
	
	var _radium = __webpack_require__("./node_modules/radium/lib/index.js");
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _ArticleImageWithText = __webpack_require__("./src/components/ArticleImageWithText.js");
	
	var _ArticleImageWithText2 = _interopRequireDefault(_ArticleImageWithText);
	
	var _ArticleHighlight = __webpack_require__("./src/components/ArticleHighlight.js");
	
	var _ArticleHighlight2 = _interopRequireDefault(_ArticleHighlight);
	
	var _breakpoints = __webpack_require__("./src/utils/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _utilFunctions = __webpack_require__("./src/utils/util-functions.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParentGuide = exports.ParentGuide = function (_Component) {
	  _inherits(ParentGuide, _Component);
	
	  function ParentGuide() {
	    _classCallCheck(this, ParentGuide);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ParentGuide.prototype.render = function render() {
	    var _this2 = this;
	
	    var brand = (0, _utilFunctions.getLang)();
	    var guideTypes = _data2.default.guideTypesData[brand].guideTypesData;
	    var guides = _data2.default.guideArticlesData[brand].guideArticlesData;
	    return _react2.default.createElement(
	      'div',
	      null,
	      guideTypes.map(function (guideType, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, className: 'col-md-4 col-sm-6 col-xs-12' },
	          _react2.default.createElement(
	            'h3',
	            { style: styles.h3style },
	            guideType.title
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row', style: styles.typeContainer },
	            guides.map(function (guide, a) {
	              if (guide.articleType.fields.type === guideType.type) {
	                if (guide.articleImage) return _react2.default.createElement(
	                  'div',
	                  { style: styles.singleArticleLink, onClick: function onClick() {
	                      return _this2.props.clickFunc(guide.articleHeadline);
	                    }, className: 'col-xs-12', key: a },
	                  _react2.default.createElement(
	                    'div',
	                    { style: styles.dividerSingleItem },
	                    _react2.default.createElement(_ArticleImageWithText2.default, { key: a, headline: guide.articleHeadline, image: guide.articleImage.fields.file.url })
	                  )
	                );
	                if (guide.articleHighlight) return _react2.default.createElement(
	                  'div',
	                  { style: styles.singleArticleLink, onClick: function onClick() {
	                      return _this2.props.clickFunc(guide.articleHeadline);
	                    }, className: 'col-xs-12', key: a },
	                  _react2.default.createElement(
	                    'div',
	                    { style: styles.dividerSingleItem },
	                    _react2.default.createElement(_ArticleHighlight2.default, { key: a, headline: guide.articleHeadline })
	                  )
	                );
	                return _react2.default.createElement(
	                  'div',
	                  { style: styles.singleArticleLink, onClick: function onClick() {
	                      return _this2.props.clickFunc(guide.articleHeadline);
	                    }, className: 'col-xs-12', key: a },
	                  _react2.default.createElement(
	                    'div',
	                    { style: styles.dividerSingleItem },
	                    guide.articleHeadline
	                  )
	                );
	              }
	            })
	          )
	        );
	      })
	    );
	  };
	
	  return ParentGuide;
	}(_react.Component);
	
	;
	exports.default = (0, _radium2.default)(ParentGuide);
	
	
	var styles = (_styles = {
	  width: '100%',
	  margin: '0 auto'
	}, _styles[_breakpoints2.default.media.siteOverMaxWidth] = {
	  width: _breakpoints2.default.width.site
	}, _styles.firstRow = {
	  marginTop: _breakpoints2.default.componentDivider
	}, _styles.divider = {
	  marginTop: 20
	}, _styles.singleArticle = {
	  marginTop: 20,
	  paddingTop: 20,
	  paddingRight: 20,
	  paddingBottom: 20,
	  marginLeft: 20,
	  paddingLeft: 0
	}, _styles.typeContainer = {
	  paddingRight: 40
	}, _styles.dividerSingleItem = {
	  borderBottom: 'solid black 1px',
	  marginTop: 20,
	  paddingBottom: 20
	}, _styles.singleArticleLink = {
	  textDecoration: 'none',
	  color: _colors2.default.darkBlue,
	  ':hover': {
	    cursor: 'pointer'
	  }
	}, _styles.h3style = {
	  lineHeight: 1.4,
	  marginBottom: 20,
	  fontFamily: 'Merriweather'
	}, _styles);

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/codebuild/output/src580589704/src/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/codebuild/output/src580589704/src/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/codebuild/output/src580589704/src/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/codebuild/output/src580589704/src/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/codebuild/output/src580589704/src/node_modules/babel-preset-stage-0/lib/index.js\",\"/codebuild/output/src580589704/src/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/guides/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.IndexPage = undefined;
	
	var _firstRow, _responsiveDivider, _styles;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Blueitems = __webpack_require__("./src/components/Blueitems.js");
	
	var _Blueitems2 = _interopRequireDefault(_Blueitems);
	
	var _VettrisHeader = __webpack_require__("./src/components/VettrisHeader.js");
	
	var _VettrisHeader2 = _interopRequireDefault(_VettrisHeader);
	
	var _breakpoints = __webpack_require__("./src/utils/breakpoints.js");
	
	var _breakpoints2 = _interopRequireDefault(_breakpoints);
	
	var _data = __webpack_require__("./contentfuldata/data.json");
	
	var _data2 = _interopRequireDefault(_data);
	
	var _radium = __webpack_require__("./node_modules/radium/lib/index.js");
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _MapComponent = __webpack_require__("./src/components/MapComponent.js");
	
	var _MapComponent2 = _interopRequireDefault(_MapComponent);
	
	var _NewsLetter = __webpack_require__("./src/components/NewsLetter.js");
	
	var _NewsLetter2 = _interopRequireDefault(_NewsLetter);
	
	var _VettrisFooter = __webpack_require__("./src/components/VettrisFooter.js");
	
	var _VettrisFooter2 = _interopRequireDefault(_VettrisFooter);
	
	var _ArticleImageWithText = __webpack_require__("./src/components/ArticleImageWithText.js");
	
	var _ArticleImageWithText2 = _interopRequireDefault(_ArticleImageWithText);
	
	var _ArticleHighlight = __webpack_require__("./src/components/ArticleHighlight.js");
	
	var _ArticleHighlight2 = _interopRequireDefault(_ArticleHighlight);
	
	var _GuideArticle = __webpack_require__("./src/components/GuideArticle.js");
	
	var _GuideArticle2 = _interopRequireDefault(_GuideArticle);
	
	var _utilFunctions = __webpack_require__("./src/utils/util-functions.js");
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _ParentGuide = __webpack_require__("./src/components/ParentGuide.js");
	
	var _ParentGuide2 = _interopRequireDefault(_ParentGuide);
	
	var _lodash = __webpack_require__("./node_modules/lodash/lodash.js");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Breadcrumbs = __webpack_require__("./src/components/Breadcrumbs.js");
	
	var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = exports.IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage(props, context) {
	    _classCallCheck(this, IndexPage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.state = {
	      searchString: { article: "" },
	      path: ""
	    };
	    _this.changeUrl = _this.changeUrl.bind(_this);
	    _this.onPopstate = _this.onPopstate.bind(_this);
	    _this.onHashChange = _this.onHashChange.bind(_this);
	    return _this;
	  }
	
	  IndexPage.prototype.changeUrl = function changeUrl(headline) {
	    this.props.history.push("/" + this.state.path[0] + "/#article=" + (0, _utilFunctions.prettifyUrl)(headline));
	    this.setState({
	      searchString: { article: (0, _utilFunctions.prettifyUrl)(headline) }
	    });
	  };
	
	  IndexPage.prototype.onPopstate = function onPopstate() {
	    this.setState({
	      searchString: window.location.hash ? { article: window.location.hash.split("article=")[1] } : ""
	    });
	  };
	
	  IndexPage.prototype.onHashChange = function onHashChange() {
	    this.setState({
	      searchString: window.location.hash ? { article: window.location.hash.split("article=")[1] } : ""
	    });
	  };
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    setTimeout(function () {
	      document.body.scrollTop = 0;
	    }, 2);
	
	    this.setState({
	      path: location ? location.pathname.split('/').filter(function (strPiece) {
	        return strPiece.length > 1;
	      }) : "",
	      searchString: location ? { article: window.location.hash.split("article=")[1] } : { article: "" }
	    });
	    window.addEventListener("popstate", this.onPopstate);
	    window.addEventListener("hashchange", this.onHashChange);
	  };
	
	  IndexPage.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('popstate', this.onPopstate);
	    window.removeEventListener('hashchange', this.onHashChange);
	  };
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var brand = (0, _utilFunctions.getLang)();
	    var items = _data2.default.servicesData[brand].services;
	    var title = _data2.default.singleData[brand].singleData.frontpageItemHeader;
	    var secondTitle = _data2.default.singleData[brand].singleData.frontpageSecondTitle;
	    var paragraph = _data2.default.singleData[brand].singleData.frontpagelongtext;
	    var mapTitle = _data2.default.singleData[brand].singleData.frontpageMapTitle;
	    var mapItems = _data2.default.clinicsData[brand].clinicsData;
	    var emailText = _data2.default.singleData[brand].singleData.frontpageEmailText;
	    var guides = _data2.default.guideArticlesData[brand].guideArticlesData;
	    var currenNewstTitle = _data2.default.singleData[brand].singleData.frontpageWidgetTitle;
	
	    var SingleGuide = function SingleGuide(props) {
	      var mappedByUrlArticles = guides.map(function (item) {
	        return { url: (0, _utilFunctions.prettifyUrl)(item.articleHeadline), item: item };
	      });
	
	      var articleByUrl = _lodash2.default.find(mappedByUrlArticles, function (item) {
	        return item.url === props.article;
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'col-xs-12', style: styles.divider },
	        articleByUrl ? _react2.default.createElement(_GuideArticle2.default, { activeLink: props.article, path: _this2.state.path[0], articles: mappedByUrlArticles, history: _this2.props.history }) : "404 Article not found."
	      );
	    };
	
	    var componentByPath = this.state.searchString.article ? _react2.default.createElement(SingleGuide, { article: this.state.searchString.article, history: this.props.history }) : _react2.default.createElement(_ParentGuide2.default, { clickFunc: this.changeUrl, history: this.props.history });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_VettrisHeader2.default, { history: this.props.history }),
	      _react2.default.createElement(
	        _radium.StyleRoot,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: styles },
	          _react2.default.createElement(_Breadcrumbs2.default, null),
	          componentByPath,
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12 col-md-8' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(
	                  'h2',
	                  { style: { marginTop: _breakpoints2.default.componentDivider, fontFamily: 'Merriweather' } },
	                  title
	                )
	              ),
	              _react2.default.createElement(_Blueitems2.default, { items: items, history: this.props.history }),
	              _react2.default.createElement('div', { className: 'clearfix' }),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                ' ',
	                _react2.default.createElement(
	                  'h2',
	                  { style: { marginTop: _breakpoints2.default.componentDivider, fontFamily: 'Merriweather' } },
	                  secondTitle
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  paragraph
	                )
	              ),
	              _react2.default.createElement('div', { className: 'clearfix', style: { marginTop: _breakpoints2.default.componentDivider } }),
	              _lodash2.default.sortBy(guides.filter(function (g) {
	                return g.articleHighlight;
	              }), [function (guide) {
	                return guide.articleImage;
	              }]).map(function (guide, a) {
	                if (guide.articleImage) return _react2.default.createElement(
	                  'div',
	                  { style: styles.singleArticleLink, onClick: function onClick() {
	                      return _this2.changeUrl(guide.articleHeadline);
	                    }, className: 'col-xs-12', key: a },
	                  _react2.default.createElement(
	                    'div',
	                    { style: styles.dividerSingleItem },
	                    _react2.default.createElement(_ArticleImageWithText2.default, { key: a, twoPanels: true, title: currenNewstTitle, headline: guide.articleHeadline, image: guide.articleImage.fields.file.url })
	                  )
	                );
	                if (guide.articleHighlight) return _react2.default.createElement(
	                  'div',
	                  { style: styles.singleArticleLink, onClick: function onClick() {
	                      return _this2.changeUrl(guide.articleHeadline);
	                    }, className: 'col-xs-12 col-md-6', key: a },
	                  _react2.default.createElement(
	                    'div',
	                    { style: styles.dividerSingleItem },
	                    _react2.default.createElement(_ArticleHighlight2.default, { key: a, headline: guide.articleHeadline })
	                  )
	                );
	                return _react2.default.createElement(
	                  'div',
	                  { style: styles.singleArticleLink, onClick: function onClick() {
	                      return _this2.changeUrl(guide.articleHeadline);
	                    }, className: 'col-xs-12 col-md-6', key: a },
	                  _react2.default.createElement(
	                    'div',
	                    { style: styles.dividerSingleItem },
	                    guide.articleHeadline
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4 col-xs-12', style: styles.firstRow },
	              _react2.default.createElement(_MapComponent2.default, { items: mapItems, title: mapTitle, history: this.props.history })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-xs-12' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_NewsLetter2.default, { text: emailText })
	              )
	            )
	          ),
	          _react2.default.createElement('div', { style: { marginTop: _breakpoints2.default.componentDivider } })
	        )
	      ),
	      _react2.default.createElement(_VettrisFooter2.default, null)
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = (0, _radium2.default)(IndexPage);
	
	
	var styles = (_styles = {
	  width: '100%',
	  margin: '0 auto'
	}, _styles[_breakpoints2.default.media.siteOverMaxWidth] = {
	  width: _breakpoints2.default.width.site
	}, _styles.firstRow = (_firstRow = {
	  marginTop: 90
	}, _firstRow[_breakpoints2.default.media.siteUnderPadWidth] = {
	  marginTop: 20
	}, _firstRow), _styles.divider = {
	  marginTop: 20
	}, _styles.singleArticle = {
	  marginTop: 20,
	  paddingTop: 20,
	  paddingRight: 20,
	  paddingBottom: 20,
	  marginLeft: 20,
	  paddingLeft: 0
	}, _styles.typeContainer = {
	  paddingRight: 40
	}, _styles.dividerSingleItem = {
	  marginTop: 10,
	  paddingTop: 10,
	  paddingBottom: 10
	}, _styles.singleArticleLink = {
	  textDecoration: 'none',
	  color: _colors2.default.darkBlue,
	  ':hover': {
	    cursor: 'pointer'
	  }
	}, _styles.responsiveDivider = (_responsiveDivider = {
	  marginTop: _breakpoints2.default.componentDivider
	}, _responsiveDivider[_breakpoints2.default.media.siteUnderPadWidth] = {
	  marginTop: _breakpoints2.default.mobileDivider
	}, _responsiveDivider), _styles);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-guides-index-js-fe885bde812fea4b2126.js